<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes" hide-footer :onClose="onClose">
    <div v-if="tab === 1" class="row">
      <div class="col-12 mb-3 mt-1">
        <div class="generalTitleItemModal">{{ "¿Estás seguro que quieres '"+ action +"' la promoción '"+promotion.name+"'?" }}</div>
      </div>
      <div class="col-12 mb-3 mt-1 d-flex align-items-center justify-content-between">
        <button class="btn generalSecondaryButton" @click="onClose()"
          :disabled="loading">NO</button>
        <button class="btn btn-primary generalPrimaryButton" @click="aceptarAction()"
          :disabled="loading">
          <img v-if="loading" src="../../../../../assets/loader.svg" height="20" alt="">
          <template v-if="!loading">
            SI
          </template>
        </button>
      </div>
    </div>
    <div v-if="tab === 2" class="row">
      <div class="col-12 mb-3 mt-1">
        <div class="generalTitleItemModal">{{ message }}</div>
      </div>
      <div class="col-12 mb-3 mt-1 d-flex align-items-center justify-content-end">
        <button class="btn btn-primary generalPrimaryButton" @click="onClose()"
          :disabled="false">CERRAR</button>
      </div>
    </div>
    <button :id="id+'CierreModal'" style="display: none;" data-dismiss="modal" />
  </Modal>
</template>
<script>
import Modal from "../../../Shared/Modal.vue";
import axios from 'axios';

export default {
  name: "ModalActions",
  props: [
    "id",
    "modalTitle",
    "class",
    "promotion",
    "action",
  ],
  data() {
    return {
      classes: this.class,
      tab: 1,
      message: '',
      loading: false,
    };
  },
  components: {
    Modal,
  },
  methods: {
    selectedTab(tab) {
      this.tab = tab;
    },
    aceptarAction(){
      this.loading = true;
      let messageOK = 'Se ha realizado la acción correctamente';
      let messageKO = 'Ha ocurrido un error, inténtelo de nuevo mas tarde';

      switch (this.action) {
        case 'ACTIVAR':
        case 'DESACTIVAR':
          axios.patch(`/promotions/promotion/${this.promotion.promotionId}`,{"status": this.action === "ACTIVAR" ? "ACTIVATED" : "DEACTIVATED"})
            .then(() => {
              this.message = messageOK;
              this.selectedTab(2);
              this.$emit("aceptarAction", '');
              this.loading = false;
            })
            .catch(() => {
              this.message = messageKO;
              this.selectedTab(2);
              this.loading = false;
          });
          break;
        case 'ELIMINAR':
          axios.delete(`/promotions/promotion/${this.promotion.promotionId}`)
            .then(() => {
              this.message = messageOK;
              this.selectedTab(2);
              this.$emit("aceptarAction", '');
              this.loading = false;
            })
            .catch(() => {
              this.message = messageKO;
              this.selectedTab(2);
              this.loading = false;
          });
          break;
        default:
          return false;
      }
      return false;
    },
    onClose() {
      document.querySelector(`#${this.id}CierreModal`).click();
      this.$emit("closeModal", '');
		},
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>
